import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';

const Loading = () => {
    return <InfoPage dataTestId="loading-info-page" headerText={'Loading...'} />;
};

export default Loading;
